module.exports = __webpack_public_path__ + "static/img/1.799c5a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/eng/1.png
// module id = 6lNr
// module chunks = 0